function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleAi(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  props = _objectSpread({
    title: ''
  }, props);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "15 0 200 229",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 39,
    fill: "#ea4335",
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 89,
    fill: "#ea4335",
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 139,
    fill: "#ea4335",
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 189,
    fill: "#ea4335",
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fbbc04"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 64,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 114,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 164,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 215,
    r: 14
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 39.5,
    fill: "#34a853",
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 89.5,
    fill: "#34a853",
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 139.5,
    fill: "#34a853",
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 189.5,
    fill: "#34a853",
    r: 16.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4285f4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 64,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 64,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 114,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 164,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 114,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 164,
    r: 19
  })))));
}
export { SvgGoogleAi as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI1MDAiIHZpZXdCb3g9IjE1IDAgMjAwIDIyOSIgd2lkdGg9IjI1MDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSI2OCIgY3k9IjM5IiBmaWxsPSIjZWE0MzM1IiByPSIxMiIvPjxjaXJjbGUgY3g9IjY4IiBjeT0iODkiIGZpbGw9IiNlYTQzMzUiIHI9IjEyIi8+PGNpcmNsZSBjeD0iNjgiIGN5PSIxMzkiIGZpbGw9IiNlYTQzMzUiIHI9IjEyIi8+PGNpcmNsZSBjeD0iNjgiIGN5PSIxODkiIGZpbGw9IiNlYTQzMzUiIHI9IjEyIi8+PGcgZmlsbD0iI2ZiYmMwNCI+PGNpcmNsZSBjeD0iMTExIiBjeT0iMTQiIHI9IjE0Ii8+PGNpcmNsZSBjeD0iMTExIiBjeT0iNjQiIHI9IjE0Ii8+PGNpcmNsZSBjeD0iMTExIiBjeT0iMTE0IiByPSIxNCIvPjxjaXJjbGUgY3g9IjExMSIgY3k9IjE2NCIgcj0iMTQiLz48Y2lyY2xlIGN4PSIxMTEiIGN5PSIyMTUiIHI9IjE0Ii8+PC9nPjxjaXJjbGUgY3g9IjE1My41IiBjeT0iMzkuNSIgZmlsbD0iIzM0YTg1MyIgcj0iMTYuNSIvPjxjaXJjbGUgY3g9IjE1My41IiBjeT0iODkuNSIgZmlsbD0iIzM0YTg1MyIgcj0iMTYuNSIvPjxjaXJjbGUgY3g9IjE1My41IiBjeT0iMTM5LjUiIGZpbGw9IiMzNGE4NTMiIHI9IjE2LjUiLz48Y2lyY2xlIGN4PSIxNTMuNSIgY3k9IjE4OS41IiBmaWxsPSIjMzRhODUzIiByPSIxNi41Ii8+PGcgZmlsbD0iIzQyODVmNCI+PGNpcmNsZSBjeD0iMTk2IiBjeT0iNjQiIHI9IjE5Ii8+PGNpcmNsZSBjeD0iMjUiIGN5PSI2NCIgcj0iMTAiLz48Y2lyY2xlIGN4PSIyNSIgY3k9IjExNCIgcj0iMTAiLz48Y2lyY2xlIGN4PSIyNSIgY3k9IjE2NCIgcj0iMTAiLz48Y2lyY2xlIGN4PSIxOTYiIGN5PSIxMTQiIHI9IjE5Ii8+PGNpcmNsZSBjeD0iMTk2IiBjeT0iMTY0IiByPSIxOSIvPjwvZz48L2c+PC9zdmc+";